import type { Transport } from '@sentry/core';
import { createTransport } from '@sentry/remix';

export function makeFetchTransport(options: any): Transport {
  function makeRequest(request: any) {
    if (filterSentryClientEvents(request.body)) {
      return Promise.resolve(new Response('{}', { status: 200 }));
    }

    const requestOptions: RequestInit = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      ...options.fetchOptions,
    };
    return fetch(options.url, requestOptions).then((response) => {
      return {
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      };
    });
  }
  // @ts-expect-error
  return createTransport(options, makeRequest);
}

export function filterSentryClientEvents(body: string) {
  // filter any events where mechanism is auto.browser
  const filtered = !!body.match(/"mechanism":{"type":"auto\.browser\.global_handlers"/);
  return filtered;
}
